export { default } from "./SyncClassesFromLMSInstructions";
